webpackJsonp([7],{

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(302);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22ba7304_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(345);
var normalizeComponent = __webpack_require__(89)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22ba7304_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.$store.dispatch('initRealTimeProducersListeners');
  },

  computed: {
    categoryNames: function categoryNames() {
      return this.$store.getters.categoryNamesArray;
    },
    producers: function producers() {
      return this.$store.state.producers;
    },
    producersArray: function producersArray() {
      return this.$store.getters.producerNameArray;
    },
    products: function products() {
      return this.$store.state.products;
    }
  },
  data: function data() {
    return {
      producerDialog: false,
      productDialog: false,
      producerName: '',
      producerImageUrl: '',
      producerImage: '',
      state: '',
      description1: '',
      description2: '',
      description3: '',
      email: '',
      password: '',
      phoneNumber: '',
      states: ['Nord kivu', 'Sud Kivu', 'Kinshasa', 'Kongo Centrale'],
      model: null,
      productName: '',
      productProducer: '',
      productPrice: null,
      soldAs: '',
      soldAsOf: '',
      productPricePerKgL: null,
      available: '',
      discount: null,
      category: '',
      unit: '',
      emailRules: [function (v) {
        return !!v || 'E-mail est requis';
      }, function (v) {
        return (/.+@.+/.test(v) || "L'email doit être valide"
        );
      }],
      passwordRules: [function (v) {
        return !!v || 'Mot de passe est requis';
      }],
      nameRules: [function (v) {
        return !!v || 'Ces noms sont requis';
      }, function (v) {
        return (/^[a-zA-Z' a-zA-Z a-zA-Z']{2,32}$/.test(v) || 'Les Noms doivent être valides'
        );
      }],
      description: [function (v) {
        return !!v || 'Cette description est requise';
      }, function (v) {
        return (/^\s*([^\r\n]+)\s*$/.test(v) || 'Elle doit être valide'
        );
      }],
      phoneRules: [function (v) {
        return !!v || 'Votre tel est requis';
      }, function (v) {
        return (/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/.test(v) || 'Le numero doit être valide'
        );
      }],
      priceRules: [function (v) {
        return !!v || 'Le prix en mauvais format';
      }, function (v) {
        return (/^\d+(,\d{3})*(\.\d{1,2})?$/.test(v) || 'Le prix doit être valide'
        );
      }]
    };
  },

  methods: {
    onPickFile: function onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked: function onFilePicked(event) {
      var _this = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file');
      }
      var fileReader = new FileReader();
      fileReader.addEventListener('load', function () {
        _this.producerImageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.producerImage = files[0];
      console.log(this.producerImage);
    },
    registerProducer: function registerProducer() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('REGISTER_PRODUCER', {
          producerName: this.producerName,
          producerImage: this.producerImage,
          state: this.state,
          description1: this.description1,
          description2: this.description2,
          description3: this.description3,
          phoneNumber: this.phoneNumber,
          email: this.email
        });
        this.producerDialog = false;
      }
    },
    registerProduct: function registerProduct() {
      if (this.$refs.form1.validate()) {
        this.$store.dispatch('REGISTER_PRODUCT', {
          productName: this.productName,
          productProducer: this.productProducer,
          category: this.category,
          productPrice: this.productPrice,
          productImage: this.producerImage,
          soldAs: this.soldAs,
          soldAsOf: this.soldAsOf,
          productPricePerKgL: this.productPricePerKgL,
          available: this.available,
          discount: this.discount,
          unit: this.unit,
          qty: 1
        });
        this.productDialog = false;
      }
    }
  }
});

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","md4":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"}},[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-img',{attrs:{"height":"100px","src":"/static/svgImages/farmer vector.svg","lazy-src":"/static/svgImages/farmer vector.svg","aspect-ratio":"1","contain":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('span',{staticStyle:{"font-size":"48px"}},[_vm._v(_vm._s(_vm.producers.length))]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"22px"}},[_vm._v("Producteurs")])])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"700"},model:{value:(_vm.producerDialog),callback:function ($$v) {_vm.producerDialog=$$v},expression:"producerDialog"}},[_c('v-btn',{staticClass:"primary",staticStyle:{"top":"-30px"},attrs:{"slot":"activator","icon":"","dark":"","large":""},slot:"activator"},[_c('b',[_c('v-icon',{attrs:{"large":""}},[_vm._v("add")])],1)]),_vm._v(" "),_c('v-card',{staticClass:"pa-5",staticStyle:{"border-radius":"10px"}},[_c('v-card-title',{staticStyle:{"font-size":"22px"}},[_vm._v("Ajoutez un producteur ici")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{ref:"form",staticClass:"ma-0",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"solo":"","label":"Nom du producteur","rules":_vm.nameRules,"type":"text","color":"primary"},model:{value:(_vm.producerName),callback:function ($$v) {_vm.producerName=$$v},expression:"producerName"}}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-btn',{staticClass:"primary",attrs:{"dark":""},on:{"click":_vm.onPickFile}},[_vm._v("Upload Image")]),_vm._v(" "),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","required":"","accept":"image/*"},on:{"change":_vm.onFilePicked}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-img',{attrs:{"height":"200px","src":_vm.producerImageUrl,"lazy-src":_vm.producerImageUrl,"aspect-ratio":"1"}})],1),_vm._v(" "),_c('v-autocomplete',{attrs:{"solo":"","items":_vm.states,"label":"Province","persistent-hint":""},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}}),_vm._v(" "),_c('v-text-field',{attrs:{"solo":"","multi-line":"","label":"Description 1","type":"text","required":"","rules":_vm.description},model:{value:(_vm.description1),callback:function ($$v) {_vm.description1=$$v},expression:"description1"}}),_vm._v(" "),_c('v-text-field',{attrs:{"solo":"","multi-line":"","label":"Description 2","type":"text"},model:{value:(_vm.description2),callback:function ($$v) {_vm.description2=$$v},expression:"description2"}}),_vm._v(" "),_c('v-text-field',{attrs:{"solo":"","multi-line":"","label":"Description 3","type":"text"},model:{value:(_vm.description3),callback:function ($$v) {_vm.description3=$$v},expression:"description3"}}),_vm._v(" "),_c('v-text-field',{attrs:{"solo":"","label":"Numéro de téléphone","type":"tel","rules":_vm.phoneRules,"color":"primary"},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}}),_vm._v(" "),_c('v-text-field',{attrs:{"solo":"","label":"Adresse E-mail","type":"email","required":"","rules":_vm.emailRules},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pr-1",attrs:{"xs12":"","md6":""}},[_c('v-btn',{staticClass:"primary",attrs:{"block":"","dark":""},on:{"click":_vm.registerProducer}},[_c('b',[_vm._v("Inscrir")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-1",attrs:{"xs12":"","md6":""}},[_c('v-btn',{attrs:{"block":""},nativeOn:{"click":function($event){_vm.producerDialog = !_vm.producerDialog}}},[_c('b',[_vm._v("Annuler")])])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","md4":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"}},[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-img',{attrs:{"height":"100px","src":"/static/svgImages/farmer vector.svg","lazy-src":"/static/svgImages/farmer vector.svg","aspect-ratio":"1","contain":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('span',{staticStyle:{"font-size":"48px"}},[_vm._v(_vm._s(_vm.products.length))]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"22px"}},[_vm._v("Produits")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"22px"}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"700"},model:{value:(_vm.productDialog),callback:function ($$v) {_vm.productDialog=$$v},expression:"productDialog"}},[_c('v-btn',{staticClass:"primary",staticStyle:{"top":"-30px"},attrs:{"slot":"activator","icon":"","dark":"","large":""},slot:"activator"},[_c('b',[_c('v-icon',{attrs:{"large":""}},[_vm._v("add")])],1)]),_vm._v(" "),_c('v-card',{staticClass:"pa-5",staticStyle:{"border-radius":"10px"}},[_c('v-card-title',{staticStyle:{"font-size":"22px"}},[_vm._v("Ajoutez un produit ici")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{ref:"form1",staticClass:"ma-0",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"solo":"","label":"Nom du produit","rules":_vm.nameRules,"type":"text","color":"primary"},model:{value:(_vm.productName),callback:function ($$v) {_vm.productName=$$v},expression:"productName"}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"solo":"","items":_vm.producersArray,"label":"Producteur","persistent-hint":""},model:{value:(_vm.productProducer),callback:function ($$v) {_vm.productProducer=$$v},expression:"productProducer"}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"solo":"","items":_vm.categoryNames,"label":"Categorie","persistent-hint":""},model:{value:(_vm.productCategory),callback:function ($$v) {_vm.productCategory=$$v},expression:"productCategory"}}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-btn',{staticClass:"primary",attrs:{"dark":""},on:{"click":_vm.onPickFile}},[_vm._v("Upload Image")]),_vm._v(" "),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","required":"","accept":"image/*"},on:{"change":_vm.onFilePicked}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-img',{attrs:{"height":"200px","src":_vm.producerImageUrl,"lazy-src":_vm.producerImageUrl,"aspect-ratio":"1"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pr-1",attrs:{"xs12":"","md5":""}},[_c('v-text-field',{attrs:{"solo":"","suffix":"CDF","type":"number","label":"Prix","required":"","rules":_vm.priceRules},model:{value:(_vm.productPrice),callback:function ($$v) {_vm.productPrice=$$v},expression:"productPrice"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-1",attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"solo":"","label":"Vendu en","type":"text","required":"","rules":_vm.name},model:{value:(_vm.soldAs),callback:function ($$v) {_vm.soldAs=$$v},expression:"soldAs"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-1",attrs:{"xs12":"","md3":""}},[_c('v-text-field',{attrs:{"solo":"","label":"De","type":"text","required":""},model:{value:(_vm.soldAsOf),callback:function ($$v) {_vm.soldAsOf=$$v},expression:"soldAsOf"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pr-1",attrs:{"xs":"","md6":""}},[_c('v-text-field',{attrs:{"solo":"","label":"Disponible","type":"number","required":""},model:{value:(_vm.available),callback:function ($$v) {_vm.available=$$v},expression:"available"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-1",attrs:{"xs":"","md6":""}},[_c('v-text-field',{attrs:{"solo":"","label":"Discompte","type":"number","required":""},model:{value:(_vm.discount),callback:function ($$v) {_vm.discount=$$v},expression:"discount"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pr-1",attrs:{"xs":"","md6":""}},[_c('v-text-field',{attrs:{"solo":"","label":"Prix par Kg ou L","required":"","type":"number","suffix":"CDF","rules":_vm.priceRules},model:{value:(_vm.productPricePerKgL),callback:function ($$v) {_vm.productPricePerKgL=$$v},expression:"productPricePerKgL"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-1",attrs:{"xs":"","md6":""}},[_c('v-text-field',{attrs:{"solo":"","label":"Unité","type":"text","required":""},model:{value:(_vm.unit),callback:function ($$v) {_vm.unit=$$v},expression:"unit"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pr-1",attrs:{"xs12":"","md6":""}},[_c('v-btn',{staticClass:"primary",attrs:{"block":"","dark":""},on:{"click":_vm.registerProduct}},[_c('b',[_vm._v("Enregistrer")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-1",attrs:{"xs12":"","md6":""}},[_c('v-btn',{attrs:{"block":""},nativeOn:{"click":function($event){_vm.productDialog = !_vm.productDialog}}},[_c('b',[_vm._v("Annuler")])])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"}},[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-img',{attrs:{"height":"100px","src":"/static/svgImages/farmer vector.svg","lazy-src":"/static/svgImages/farmer vector.svg","aspect-ratio":"1","contain":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('span',{staticStyle:{"font-size":"48px"}},[_vm._v("4")]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"22px"}},[_vm._v("Acheteur")])])],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.d2848d77afdcde620901.js